export default {"src":"/Intellisort/_next/static/media/separator-top.787275f4.svg","height":61,"width":1200,"blurWidth":0,"blurHeight":0};